module.exports = __webpack_public_path__ + "static/media/buildings-2.c8bbdd47.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/buildings-2.svg
// module id = 627
// module chunks = 1